module.exports={
	"Scope": "ProjectType-List",
	"CoreEntity": "ProjectType",
	"TitleTemplate": "Project Types",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "ProjectTypeListName",
			"PictDashboard": {}
		},
		"Hash":
		{
			"Name": "Hash",
			"Hash": "ProjectTypeListHash",
			"PictDashboard": {}
		},
		"Description":
		{
			"Name": "Description",
			"Hash": "ProjectTypeListDescription",
			"PictDashboard": {}
		},
		"Ordinal":
		{
			"Name": "Order",
			"Hash": "ProjectTypeListOrdinal",
			"PictDashboard": {}
		}
	}
}
